import { trackEvent } from "../utils/track-event";
import type {
  CarouselEventBaseProps,
  CarouselEventProps,
  TrackingEvent,
  TrackingEventResponse,
} from "../utils/types";
import { mapCarouselItems, mapVisibleCarouselItems } from "../utils/helpers";

type CarouselViewedEventProps = CarouselEventBaseProps & {
  visibleIndexes?: number[];
};

export type CarouselViewedEvent = TrackingEvent<
  "Carousel Viewed",
  Omit<CarouselEventProps, "item">
>;

export async function trackCarouselViewedEvent({
  title,
  subtitle,
  items,
  contentType,
  shopType,
  carouselPosition,
  imageUrl,
  carouselId,
  targetLink,
  targetType,
  responseSourceType,
  resultId,
  gated,
  tab,
  visibleIndexes = [],
}: CarouselViewedEventProps): TrackingEventResponse {
  const mappedItems = mapCarouselItems(items);

  return await trackEvent("Carousel Viewed", {
    props: {
      title,
      subtitle,
      items: mappedItems,
      visible_items: mapVisibleCarouselItems(items, visibleIndexes),
      carousel_content_type: contentType,
      num_items: mappedItems.length,
      shop_type: shopType,
      carousel_position: carouselPosition,
      carousel_id: carouselId,
      image_url: imageUrl,
      target_link: targetLink,
      target_type: targetType,
      response_source_type: responseSourceType,
      result_id: resultId,
      gated,
      tab,
    },
    withRequestSource: true,
  });
}
